import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { DispatchService } from '../../services/dispatch.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { P } from '@angular/cdk/keycodes';
import { Subscription } from 'rxjs';
import { customerBranchEmailValidators, isCustomerEmailRequired } from '../../shared/customer-email-config';
import { OcmService, OcmNormalized } from '../../services/ocm.service';

@Component({
	selector: 'app-customer-create',
	templateUrl: './customer-create.component.html',
	styleUrls: ['./customer-create.component.scss']
})
export class CustomerCreateComponent implements OnInit, OnDestroy {
	get customerEmailRequired(): boolean {
		return isCustomerEmailRequired(this.config);
	}
	@ViewChild('stepper', { static: true }) stepper: MatStepper;
	@ViewChild('detailsModal') detailsModalEle: ElementRef;
	debtorFromGroup: UntypedFormGroup;
	branchFormGroup: UntypedFormGroup;
	contactFormGroup: UntypedFormGroup;
	isEditable = true;
	terms: any = [];
	customertypes: any = [];
	holdreasons: any = [];
	currencies: any = [];
	salestypes: any = [];
	zones: any = [];
	taxes: any = [];
	alltaxes: any = [];
	locations: any = [];
	areas: any = [];
	territories: any = [];
	salesman: any = [];
	shipvia: any = [];
	tirefee = true;
	disabledbranch = false;
	customer_created: any = [];
	paymentmethods: any = [];
	phone: any = '';
	place: any = false;
	routes: any = [];
	//todo make this part of configurations or define company variables on login
	defaults = {
		country: 'United States',
		region: 'MA',
		holdreason: '1',
		currency: 'USD',
		terms: 'COD',
		salestype: 'A1',
		customertype: '1',
		discount: 0,
		credit: 0,
		email_invoice: false,
		requirepo: false,
		email_statement: false,
		interest: 3,
		warehouse: '1',
		shipvia: '1',
		area: 'A00',
		territory: '1',
		salesman: '01',
		disabled: false,
		tirefee: true,
		taxauth: '31',
		branchcode: '00',
		default_paymentmehod: '2',
		cosm_license: '',
		licExpDate: '',
		signed_mor: false,
	};

	color = '';
	config: any = false;
	index = 1;
	duplicatewarning: any;
	modalAction: boolean;
	contacttypes: any = false;
	contacts: any = [];
	ediYesNo: any[];
	routesbyzip: any = false;
	storedRoute: any = false;
	country = 'us';
	private subscriptions = new Subscription();

	// OCM (NY Office of Cannabis Management) license verification state
	ocmVerifying = false;
	ocmResult: OcmNormalized | null = null;
	ocmStatus: 'idle' | 'ok' | 'warn' | 'error' = 'idle';
	ocmMessage = '';
	// Suffixed form (`OCM-RETL-26-000493-D1`) discovered by the Metrc probe at verify
	// time; carried through to the save payload so debtorsmaster.metrc_recipient_license
	// is populated immediately and the first outgoing transfer succeeds.
	ocmMetrcRecipientLicense: string | null = null;
	ocmMetrcProbeMessage = '';

	// Salon Prospect → Convert: prefill payload handed over via router state from
	// the Salon Prospects screen. Captured in the constructor (getCurrentNavigation
	// is only populated during the in-flight navigation) and applied in ngOnInit.
	private pendingSalonProspect: any = null;
	prospectPrefilled = false;

	constructor(public dispatchService: DispatchService, public router: Router, private fb: UntypedFormBuilder, public globalsService: GlobalsService, public customerService: CustomerService, public location: Location, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private ocmService: OcmService) {
		this.globalSearchService.mesagesallowed.next(false);
		this.globalSearchService.aiDataAvailable$.next(null);
		const navState = this.router.getCurrentNavigation()?.extras?.state as any;
		this.pendingSalonProspect = navState?.salonProspect || null;
	}



	ngOnInit(): void {


		this.subscriptions.add(
			this.globalSearchService.configsubscription.subscribe(c => {
				this.config = c;

				if (this.config?.defaults?.country === 'Canada') {
					this.country = 'ca';
				} else {
					this.country = 'us';
				}
				this.defaults = c.defaults;
				this.patchBranchEmailValidators();
			})
		);

		this.color = this.globalSearchService.getColor();

		this.subscriptions.add(
			this.dispatchService.getRoutes().subscribe((r: any) => {
				this.routes = r;
			})
		);

		this.subscriptions.add(
			this.dispatchService.getZipCodeRoutes().subscribe((r: any) => {
				this.routesbyzip = r;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.taxgroups.subscribe((results: any) => {
				this.taxes = results;
				this.alltaxes = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.salespeople.subscribe((results: any) => {
				this.salesman = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.shipvia.subscribe((results: any) => {
				this.shipvia = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.terms.subscribe((results: any) => {
				this.terms = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.zones.subscribe((results: any) => {
				this.zones = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.holdreasons.subscribe((results: any) => {
				this.holdreasons = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.locations.subscribe((results: any) => {
				this.locations = results;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.customertypes.subscribe(details => {
				this.customertypes = details;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.currencies.subscribe(details => {
				this.currencies = details;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.salestypes.subscribe(details => {
				this.salestypes = details;
			})
		);

		this.subscriptions.add(
			this.globalSearchService.areas.subscribe(details => {
				this.areas = details;
			})
		);

		this.subscriptions.add(
			this.globalsService.getTerritories().subscribe((details: any) => {
				this.territories = details;
			})
		);

		this.subscriptions.add(
			this.globalsService.getPaymentMethods().subscribe(details => {
				this.paymentmethods = details;
			})
		);
		this.ediYesNo = [
			{ value: 'Y', view: 'Yes' },
			{ value: 'N', view: 'No' }
		]

		this.subscriptions.add(
			this.globalsService.getTypes().subscribe( (results: any) => {
				this.globalSearchService.all_system_types.next(results);
				this.contacttypes = results.contacttypes
				this.contactFormGroup = this.fb.group({
					contid: [0],
					name: ['', Validators.required],
					email: ['', [Validators.email]],
					phone: [''],
					role: [
						[], Validators.required
					],
				});
			})
		);
		;

		this.debtorFromGroup = this.fb.group({
			name: ['', [Validators.required]],
			address1: ['', [Validators.required]],
			address2: ['', []],
			address3: ['', [Validators.required]],
			address4: [this.defaults.region, [Validators.required]],
			address5: ['', [Validators.required]],
			address6: [this.defaults.country, [Validators.required]],
			creditlimit: [this.defaults.credit, [Validators.required]],
			discount: [this.defaults.discount, [Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			pymtdiscount: [this.defaults.discount, [Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			arintrate: [this.defaults.interest],
			paymentterms: [this.defaults.terms, [Validators.required]],
			salestype: [this.defaults.salestype, [Validators.required]],
			typeid: [this.defaults.customertype, [Validators.required]],
			holdreason: [this.defaults.holdreason, [Validators.required]],
			currcode: [this.defaults.currency, [Validators.required]],
			emailstatement: [this.defaults.email_statement, [Validators.required]],
			statementemailaddress: ['', [Validators.email]],
			edireference: ['', [Validators.required]],
			ediinvoices: [this.defaults.email_invoice, [Validators.required]],
			invoiceemailaddress: ['', [Validators.email]],
			customerpoline: [this.defaults.requirepo, [Validators.required]],
			cosm_license: [this.defaults.cosm_license, []],
			licExpDate: [this.defaults.licExpDate, []],
			signed_mor: [this.defaults.signed_mor, []],
		});

		this.debtorFromGroup.get('paymentterms')?.valueChanges.subscribe(newValue => {
			if (!newValue || !Array.isArray(this.terms)) {return;}

			const termcode = this.terms.find(t => t?.termsindicator === newValue);

			if (
				termcode &&
				termcode.collect_payment &&
				String(termcode.collect_payment) === '1'
			) {
				const creditCtrl = this.debtorFromGroup.get('creditlimit');
				if (creditCtrl) {
					creditCtrl.setValue('0.00');
				}
			}
		});


		this.debtorFromGroup.get('emailstatement').valueChanges.subscribe((newValue: any) => {
			if (newValue) {
				this.debtorFromGroup.get('statementemailaddress').setValidators([Validators.required])
				this.debtorFromGroup.get('statementemailaddress').updateValueAndValidity();
			} else {
				this.debtorFromGroup.get('statementemailaddress').clearValidators()
				this.debtorFromGroup.get('statementemailaddress').updateValueAndValidity();
			}
		})

		this.debtorFromGroup.get('ediinvoices').valueChanges.subscribe((newValue: any) => {
			if (newValue) {
				this.debtorFromGroup.get('invoiceemailaddress').setValidators([Validators.required])
				this.debtorFromGroup.get('invoiceemailaddress').updateValueAndValidity();
			} else {
				this.debtorFromGroup.get('invoiceemailaddress').clearValidators()
				this.debtorFromGroup.get('invoiceemailaddress').updateValueAndValidity();
			}
		})

		this.debtorFromGroup.get('address5').valueChanges.subscribe((newValue: any) => {
			if (this.config.env.package == 'tires') {
				const zip = newValue;
				if (zip) {
					const match = this.routesbyzip.find((i) => i.zipcode === zip)
					this.storedRoute = match ? match['routeid'] : false;
				} else {
					this.storedRoute = false;
				}
			}
		})

		this.updateBranch();
		this.markFormGroupTouched(this.debtorFromGroup);

		if (this.pendingSalonProspect) {
			this.applyProspectPrefill(this.pendingSalonProspect);
			this.pendingSalonProspect = null;
		}
	}

	markFormGroupTouched(form: UntypedFormGroup) {
		for (const key in form.controls) {
			if (form.controls.hasOwnProperty(key)) {
				const control = form.controls[key];
				control.markAsTouched();
				control.updateValueAndValidity();
			}
		}
	}

	selectCustomer(event: any) {

		this.customerService.getDebtor(event.debtorno).subscribe( (results: any) => {

			this.debtorFromGroup.get('name').setValue(results.customer.name)
			this.debtorFromGroup.get('address1').setValue(results.customer.address1)
			this.debtorFromGroup.get('address2').setValue(results.customer.address2)
			this.debtorFromGroup.get('address3').setValue(results.customer.address3)
			this.debtorFromGroup.get('address4').setValue(results.customer.address4)
			this.debtorFromGroup.get('address5').setValue(results.customer.address5)

			this.debtorFromGroup.get('creditlimit').setValue(results.customer.creditlimit)
			this.debtorFromGroup.get('customerpoline').setValue(results.customer.customerpoline)

			this.branchFormGroup.get('brname').setValue(results.customer.brname)
			this.branchFormGroup.get('braddress1').setValue(results.customer.braddress1)
			this.branchFormGroup.get('braddress2').setValue(results.customer.braddress2)
			this.branchFormGroup.get('braddress3').setValue(results.customer.braddress3)
			this.branchFormGroup.get('braddress4').setValue(results.customer.braddress4)
			this.branchFormGroup.get('braddress5').setValue(results.customer.braddress5)
			this.branchFormGroup.get('contactname').setValue(results.customer.contactname)

		});
	}

	/**
	 * Look up the entered cosm_license against the NY OCM open-data dataset.
	 * Confirms the license is real + Active, then prefills name/expiry/address
	 * from the OCM record so the rep doesn't retype the document.
	 */
	verifyOcmLicense(): void {
		const lic = (this.debtorFromGroup.get('cosm_license')?.value || '').toString().trim();
		if (!lic) {
			this.ocmStatus = 'error';
			this.ocmMessage = 'Enter a license number first';
			this.ocmResult = null;
			return;
		}
		this.ocmVerifying = true;
		this.ocmStatus = 'idle';
		this.ocmMessage = '';
		this.ocmResult = null;
		this.ocmMetrcRecipientLicense = null;
		this.ocmMetrcProbeMessage = '';
		// probeMetrc=true: in one round-trip we get OCM data + the Metrc-required
		// suffix, so save can write debtorsmaster.metrc_recipient_license inline.
		this.ocmService.lookup(lic, { probeMetrc: true }).subscribe({
			next: (resp) => {
				this.ocmVerifying = false;
				if (!resp || resp.success === false) {
					this.ocmStatus = 'error';
					this.ocmMessage = resp?.error || 'Lookup failed';
					return;
				}
				if (!resp.found || !resp.normalized) {
					this.ocmStatus = 'error';
					this.ocmMessage = 'License not found in OCM dataset';
					return;
				}
				this.ocmResult = resp.normalized;
				this.applyOcmPrefill(resp.normalized);

				// Metrc probe (only present when OCM was found + Active)
				if (resp.metrc_probe) {
					if (resp.metrc_probe.ok && resp.metrc_probe.full_license) {
						this.ocmMetrcRecipientLicense = resp.metrc_probe.full_license;
						this.ocmMetrcProbeMessage = 'Metrc-ready: recipient license = ' + resp.metrc_probe.full_license;
					} else {
						const tried = resp.metrc_probe.candidates_tried || [];
						this.ocmMetrcProbeMessage = 'Metrc probe could not find a working suffix' +
							(tried.length ? ' (tried ' + tried.join(', ') + ')' : '') +
							(resp.metrc_probe.last_error ? ' — ' + resp.metrc_probe.last_error : '');
					}
				}

				if (resp.normalized.is_expired) {
					this.ocmStatus = 'error';
					this.ocmMessage = 'License is EXPIRED (' + resp.normalized.expiration_date + ')';
				} else if (!resp.normalized.is_active) {
					this.ocmStatus = 'warn';
					this.ocmMessage = 'License status: ' + (resp.normalized.license_status || 'Unknown') + ' — not Active';
				} else if (!resp.normalized.is_operational) {
					this.ocmStatus = 'warn';
					this.ocmMessage = 'Active but Non-Operational (not yet open to the public)';
				} else {
					this.ocmStatus = 'ok';
					this.ocmMessage = 'Active & Operational — fields prefilled from OCM';
				}
			},
			error: (err) => {
				this.ocmVerifying = false;
				this.ocmStatus = 'error';
				this.ocmMessage = (err?.error?.error || err?.message || 'Lookup failed');
			},
		});
	}

	private applyOcmPrefill(n: OcmNormalized): void {
		// debtorsmaster fields
		this.debtorFromGroup.patchValue({
			name: n.name_combined,
			cosm_license: n.license_number,
			licExpDate: n.expiration_date || '',
			address1: n.address_line_1,
			address2: n.address_line_2,
			address3: n.city,
			address4: n.state || 'NY',
			address5: n.zip_code,
		});
		// custbranch (default branch) — short DBA goes on brname,
		// "attention to" = OCM primary_contact_name (overwrite — OCM is authoritative)
		this.branchFormGroup?.patchValue({
			brname: n.short_name || n.name_combined,
			braddress1: n.address_line_1,
			braddress2: n.address_line_2,
			braddress3: n.city,
			braddress4: n.state || 'NY',
			braddress5: n.zip_code,
			contactname: n.primary_contact || this.branchFormGroup.get('contactname')?.value || '',
		});

		// Push a custcontacts row for the OCM primary contact. createCustomer()
		// fans `this.contacts` out to `custcontacts` server-side, so this lines
		// up the "attention to" contact in the canonical contacts table on first
		// save. Guard against double-clicks of Verify by deduping on name+role.
		if (n.primary_contact) {
			const already = this.contacts.some((c: any) =>
				c && (c.name || '').trim().toUpperCase() === n.primary_contact.trim().toUpperCase() &&
				Array.isArray(c.role) && c.role.indexOf('OWNER') !== -1
			);
			if (!already) {
				this.contacts.push({
					name: n.primary_contact,
					email: '',
					phone: '',
					role: ['OWNER'],
				});
			}
		}
	}

	/**
	 * Prefill the new-customer form from a Salon Prospect (NYS beautician license)
	 * handed over by the Salon Prospects screen's Convert action. Mirrors
	 * applyOcmPrefill: debtor + default branch + an OWNER contact. State is NY (all
	 * NYS appearance-enhancement licenses); the license drops onto cosm_license so
	 * the beauty license fields carry over. Terms / salesperson / tax authority are
	 * intentionally left at defaults for the user to confirm before saving.
	 */
	private applyProspectPrefill(p: any): void {
		if (!p) { return; }
		const state = (p.state || 'NY').toString();
		this.debtorFromGroup.patchValue({
			name: p.name || '',
			cosm_license: p.license_number || '',
			licExpDate: p.license_expiration_date || '',
			address1: p.address1 || '',
			address2: p.address2 || '',
			address3: p.city || '',
			address4: state,
			address5: p.zip || '',
		});
		this.branchFormGroup?.patchValue({
			brname: p.name || '',
			braddress1: p.address1 || '',
			braddress2: p.address2 || '',
			braddress3: p.city || '',
			braddress4: state,
			braddress5: p.zip || '',
			contactname: p.owner || this.branchFormGroup.get('contactname')?.value || '',
		});
		if (p.owner) {
			const already = this.contacts.some((c: any) =>
				c && (c.name || '').trim().toUpperCase() === p.owner.trim().toUpperCase() &&
				Array.isArray(c.role) && c.role.indexOf('OWNER') !== -1
			);
			if (!already) {
				this.contacts.push({ name: p.owner, email: '', phone: '', role: ['OWNER'] });
			}
		}
		this.prospectPrefilled = true;
	}

	updateContactName(event: any, note: any) {
		const index = this.contacts.indexOf(note);
		this.contacts[index].name = event.target.value;
	}

	updateContactEmail(event: any, note: any) {
		const index = this.contacts.indexOf(note);
		const isok = this.isEmail(event.target.value);

		this.contacts[index].email = event.target.value;
	}

	updateContactPhone(event: any, note: any) {
		const index = this.contacts.indexOf(note);
		this.contacts[index].phone = event.target.value;
	}

	updateContactRole(event: any, note: any) {
		const index = this.contacts.indexOf(note);
		this.contacts[index].role = event.target.value;
	}

	prefillContact() {

		const email = this.branchFormGroup.get('email').value;
		const phone = this.branchFormGroup.get('phoneno').value;
		const name = this.branchFormGroup.get('contactname').value;


		if (email != '' || phone != '' || name != '') {
			this.contactFormGroup.get('phone').patchValue(phone)
			this.contactFormGroup.get('email').patchValue(email);
			this.contactFormGroup.get('name').patchValue(name);
			this.contactFormGroup.get('role').patchValue(['OWNER']);
			this.addContact()
		}

	}

	private patchBranchEmailValidators(): void {
		const ctrl = this.branchFormGroup?.get('email');
		if (!ctrl) {
			return;
		}
		ctrl.setValidators(customerBranchEmailValidators(this.config));
		ctrl.updateValueAndValidity();
		this.branchFormGroup.updateValueAndValidity();
	}

	updateBranch() {


		this.branchFormGroup = this.fb.group({
			branchcode: [this.defaults.branchcode, [Validators.required]],
			//debtorno: [''],
			brname: [this.debtorFromGroup.controls.name.value, [Validators.required]],
			contactname: ['', [Validators.required]],
			braddress1: [this.debtorFromGroup.controls.address1.value, [Validators.required]],
			braddress2: [this.debtorFromGroup.controls.address2.value],
			braddress3: [this.debtorFromGroup.controls.address3.value, [Validators.required]],
			braddress4: [this.debtorFromGroup.controls.address4.value, [Validators.required]],
			braddress5: [this.debtorFromGroup.controls.address5.value, [Validators.required]],
			braddress6: [this.debtorFromGroup.controls.address6.value, [Validators.required]],
			//estdeliverydays: [''],
			phoneno: [this.phone, [Validators.required]],
			email: ['', customerBranchEmailValidators(this.config)],
			faxno: [''],
			disabletrans: [this.defaults.disabled],
			tirefee: [this.defaults.tirefee],
			defaultlocation: [this.defaults.warehouse, [Validators.required]],
			defaultshipvia: [this.defaults.shipvia, [Validators.required]],
			area: [this.defaults.area, [Validators.required]],
			salesman: [this.defaults.salesman, [Validators.required]],
			tax_ref: [''],
			taxgroupid: [this.defaults.taxauth, [Validators.required]],
			specialinstructions: [''],
			username: [''],
			password: [''],
			lat: [],
			lng: [],
			bypass: false,
			route: ['', [Validators.required]],
			default_paymentmehod: [this.defaults.default_paymentmehod, [Validators.required]],
			territory_id: ['1'],
			//pricelevel: [''],

		});

		if (this.config.env.package == 'tires' && this.storedRoute) {
			this.branchFormGroup.get('route').setValue(this.storedRoute);
		}

		if (this.place) {
			this.branchFormGroup.get('lat').setValue(this.place.geometry.location.lat())
			this.branchFormGroup.get('lng').setValue(this.place.geometry.location.lng())
		}

		this.branchFormGroup.get('email').valueChanges.subscribe(newValue => {
			const valuetest = this.branchFormGroup.get('username').value;
			if (valuetest != newValue || valuetest == '') {
				this.branchFormGroup.get('username').setValue(newValue);
			}

		})

		this.branchFormGroup.get('braddress5').valueChanges.subscribe(newValue => {
			// Moov sells wholesale to licensed dispensaries: the tax is NYS cannabis excise,
			// never a county retail sales-tax group. zipcodelookup can only ever return
			// 1NY/2NY/3NY county groups (it matches taxgroupdescription against the county
			// name), so letting it run both auto-selected the wrong group and narrowed the
			// dropdown so "No Tax Distributor Exempt" could not be picked at all.
			if (this.isCannabisTaxClient()) {
				this.taxes = this.alltaxes;
				return;
			}
			const data_search = {
				zipcode: newValue
			}
			this.customerService.zipCodeCheck(data_search).subscribe( (results: any) => {
				if (results && results.length) {
					this.taxes = results;
					this.branchFormGroup.get('taxgroupid').setValue(results[0].taxgroupid)
				} else {
					this.taxes = this.alltaxes;
				}
			});
		});

		if (this.config && this.config.env.package == 'beauty') {
			this.branchFormGroup.get('route').setValidators([])
			this.branchFormGroup.get('default_paymentmehod').setValidators([])
		}
		const branchEmail = this.branchFormGroup.get('email');
		branchEmail.setValidators(customerBranchEmailValidators(this.config));
		branchEmail.updateValueAndValidity();
		this.branchFormGroup.updateValueAndValidity();

		this.branchFormGroup.get('tax_ref').valueChanges.subscribe(newvalue => {
			if (newvalue != '') {
				let currentValue = this.alltaxes.filter(v => {
					return v.taxgroupid == this.branchFormGroup.get('taxgroupid').value
				})[0];

				if (currentValue) {
					currentValue = currentValue.taxgroupdescription
				} else {
					currentValue = '';
				}

				this.filterTaxAuths(true, currentValue);
			} else {
				this.filterTaxAuths(false, '');
			}
		});

		this.branchFormGroup.markAllAsTouched();
	}

	/** Clients whose customers are taxed by cannabis excise, not county retail sales tax. */
	isCannabisTaxClient(): boolean {
		const client = this.config?.env?.client;
		return client === 'moov' || client === 'moov_sandbox';
	}

	back(): void {
		this.location.back()
	}

	updateZones(input: any) {

	}

	getAddress(place: any) {
		this.place = place


		const componenets = place['address_components'];
		const name = place['name'];
		const phone = place['formatted_phone_number'];
		const website = place['website'];

		const address1 = this.parseComponentShortName(componenets, ['street_number', 'route']);
		const address2 = this.parseComponentShortName(componenets, ['subpremise']);
		const address3 = this.parseComponentShortName(componenets, ['locality']);
		const address4 = this.parseComponentShortName(componenets, ['administrative_area_level_1']);
		const address5 = this.parseComponentShortName(componenets, ['postal_code']);
		const address6 = this.parseComponentLongName(componenets, ['country']);

		this.debtorFromGroup.get('address1').setValue(address1)
		this.debtorFromGroup.get('address2').setValue(address2)
		this.debtorFromGroup.get('address3').setValue(address3)
		this.debtorFromGroup.get('address4').setValue(address4)
		this.debtorFromGroup.get('address5').setValue(address5)
		this.debtorFromGroup.get('address6').setValue(address6)

		this.branchFormGroup.get('braddress1').setValue(address1)
		this.branchFormGroup.get('braddress2').setValue(address2)
		this.branchFormGroup.get('braddress3').setValue(address3)
		this.branchFormGroup.get('braddress4').setValue(address4)
		this.branchFormGroup.get('braddress5').setValue(address5)
		this.branchFormGroup.get('braddress6').setValue(address6)
		this.branchFormGroup.get('lat').setValue(this.place.geometry.location.lat())
		this.branchFormGroup.get('lng').setValue(this.place.geometry.location.lng())

		if (name) {

			if (name !== address1) {
				this.debtorFromGroup.get('name').setValue(name);
				this.branchFormGroup.get('brname').setValue(name);
			}
		}

		if (phone) {
			this.phone = phone;
			this.branchFormGroup.get('phoneno').setValue(phone)
		}

	}

	addContact() {
		const search = this.contactFormGroup.value
		const exists = this.contacts.filter((con) => con.email == search.email && con.name == search.name && con.phone == search.phone);

		if ((!exists.length || this.contacts.length == 0) && search.name != '' && search.role.length) {
			this.contacts.push(this.contactFormGroup.value);
		}
		this.contactFormGroup.reset();
	}

	private parseComponentShortName(componenets: any, types: any) {

		const result = [];
		componenets.forEach((comp: any) => {
			const compa = comp.types.map((local: any) => {
				if (types.includes(local)) {
					const adda = (comp.short_name) ? comp.short_name : '';
					result.push(adda);
				}
			});
		})
		return result.join(' ');
	}

	private parseComponentLongName(componenets: any, types: any) {
		const result = [];
		componenets.forEach((comp: any) => {
			const compa = comp.types.map((local: any) => {
				if (types.includes(local)) {
					const adda = (comp.long_name) ? comp.long_name : '';
					result.push(adda);
				}
			});
		})
		return result.join(' ');
	}


	createCustomer() {

		this.getFormValidationErrors(this.branchFormGroup);
		this.getFormValidationErrors(this.debtorFromGroup);
		// console.log(this.debtorFromGroup);
		if (this.branchFormGroup.valid && this.debtorFromGroup.valid) {
			const debtorPayload = this.debtorFormValueWithMetrcLicense();
			this.customerService.createCustomer(debtorPayload, this.branchFormGroup.value, this.contacts).subscribe((results: any) => {
				if (results.success) {
					this.customer_created = results.customer;
					this.router.navigate(['./customers/view/' + results.customer.debtorno]);
				} else {
					const bypass = confirm(results.message);
					if (bypass) {
						this.branchFormGroup.get('bypass').setValue(true);
						this.customerService.createCustomer(this.debtorFormValueWithMetrcLicense(), this.branchFormGroup.value).subscribe((results: any) => {
							this.customer_created = results.customer;
							this.router.navigate(['./customers/view/' + results.customer.debtorno]);
						});

					}

				}
			});
		}
	}

	/**
	 * Merge the suffixed Metrc recipient license discovered at OCM-verify time
	 * into the debtor save payload. server/catalog/controller/apir/customers.php
	 * INSERTs whatever fields appear in the payload, so adding metrc_recipient_license
	 * here is enough to populate the column at create time — no offline backfill
	 * needed for new MOOV customers.
	 */
	private debtorFormValueWithMetrcLicense(): any {
		const v = { ...this.debtorFromGroup.value };
		if (this.ocmMetrcRecipientLicense) {
			v.metrc_recipient_license = this.ocmMetrcRecipientLicense;
		}
		return v;
	}

	getFormValidationErrors(form: any) {
		Object.keys(form.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = form.get(key).errors;

			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					form.markAllAsTouched();
					form.markAsUntouched()

					if (key == 'reference') {
						key = 'PO Number';
					}

					this.globalSearchService.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}

	compareAddress() {
		if (!this.debtorFromGroup.valid) { return; }
		const a1 = this.debtorFromGroup.get('address1').value;
		const a2 = this.debtorFromGroup.get('address2').value;
		const a3 = this.debtorFromGroup.get('address3').value;
		const cont = false;
		if (a1 != '' || a2 != '' || a3 != '') {
			const data = { add1: a1, add2: a2, add3: a3 }
			this.customerService.addressCompare(data).subscribe((result) => {
				if (result.length) {
					this.duplicatewarning = result;
					this.modalService.open(this.detailsModalEle, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static', keyboard: false }).result.then((result) => {}, (reason) => {

						if (this.modalAction) {
							this.updateBranch();
							this.step();
							this.modalAction = undefined;
						} else {
							this.modalAction = undefined;
						}

					});
				} else {
					this.updateBranch();
					this.step();
				}
			});

		}

	}

	isMatch(entered, found) {
		if (entered.toLowerCase() == found.toLowerCase()) {
			return true;
		}
		return false;
	}

	userSelection(input: boolean) {
		this.modalAction = input;
		this.modalService.dismissAll();
	}


	removeContact(contact: any) {
		const index = this.contacts.indexOf(contact);
		this.contacts.splice(index, 1);
	}
	step() {
		document.getElementById('stepperNext').click();
	}

	isEmail(search: string): boolean {
		let serchfind: boolean;
		const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		serchfind = regexp.test(search);
		return serchfind
	}

	filterTaxAuths(filter: any, current: any) {

		if (filter) {

			const results = this.taxes.filter((r: any) => {
				let newvalue = '';

				if (current != '') {
					newvalue = current.replace('1', '2');
				}

				if (r.taxgroupdescription.startsWith('2')) {
					if (newvalue != '' && newvalue == r.taxgroupdescription) {
						this.branchFormGroup.get('taxgroupid').setValue(r.taxgroupid);
						//this.globalSearchService.showNotification('Tax Group Updated to Non Taxable', 'warn', 'bottom', 'right');
					}
					return r;
				}
			})
			this.taxes = results;
		} else {
			this.taxes = this.alltaxes;
		}
	}


	setFormDefaults() {
		this.debtorFromGroup = this.fb.group({
			name: ['', [Validators.required]],
			address1: ['', [Validators.required]],
			address2: ['', []],
			address3: ['', [Validators.required]],
			address4: [this.defaults.region, [Validators.required]],
			address5: ['', [Validators.required]],
			address6: [this.defaults.country, [Validators.required]],
			creditlimit: [this.defaults.credit, [Validators.required]],
			discount: [this.defaults.discount, [Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			pymtdiscount: [this.defaults.discount, [Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			arintrate: [this.defaults.interest],
			paymentterms: [this.defaults.terms, [Validators.required]],
			salestype: [this.defaults.salestype, [Validators.required]],
			typeid: [this.defaults.customertype, [Validators.required]],
			holdreason: [this.defaults.holdreason, [Validators.required]],
			currcode: [this.defaults.currency, [Validators.required]],
			emailstatement: [this.defaults.email_statement, [Validators.required]],
			statementemailaddress: ['', [Validators.email]],
			ediinvoices: [this.defaults.email_invoice, [Validators.required]],
			invoiceemailaddress: ['', [Validators.email]],
			customerpoline: [this.defaults.requirepo, [Validators.required]],
			cosm_license: [this.defaults.cosm_license, []],
			licExpDate: [this.defaults.licExpDate, []],
			signed_mor: [this.defaults.signed_mor, []],
		});
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe(); // will clean up everything added
	}

}